// extracted by mini-css-extract-plugin
export default {"MainContainer":"Profile_MainContainer__g2Ozq","Form":"Profile_Form__G69AS"};